<video width="100%" controls autoplay controlsList="nodownload">
  <source [src]="data" type="video/mp4" />
</video>
